<template>
  <div class="store-header-component">
    <div class="store-header">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="store-header-message">
              <h2>Store</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header"
};
</script>


<style lang="sass">
.store-header
  width: auto
  height: 200px
  background: url('../../assets/images/store/header.png')
  background-size: 100% 100%
  background-repeat: no-repeat
  background-position: center center
  color: $white

  h2
    font-family: 'Might Could'
    text-transform: uppercase
    font-size: 2.5em
  
  .store-header-message
    padding: 2rem  0

@media(min-width: 992px)
  .store-header
    height: 300px

    h2
      font-size: 4em

    p
      font-size: 1em

    .store-header-message
      padding: 4rem

@media(max-width: 992px)
  .store-header
    background-size: cover

</style>
